import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info-button-fill",
  "use": "icon-info-button-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-info-button-fill\"><path d=\"M19.866 3.408c-4.544-4.544-11.913-4.544-16.458 0-4.544 4.544-4.544 11.913 0 16.457 4.544 4.544 11.913 4.544 16.458 0 4.544-4.544 4.543-11.912 0-16.457zm-6.712 13.288a1.517 1.517 0 11-3.035 0v-6.071a1.517 1.517 0 113.035 0v6.071zM11.61 8.031c-.874 0-1.458-.62-1.439-1.384-.018-.802.565-1.403 1.457-1.403.892 0 1.457.601 1.476 1.403-.001.764-.583 1.384-1.494 1.384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol